import api, { SILENT } from 'utils/axios';

// types
import { AuthUrlResponse, CallbackResponse, MeResponse, StepUpCallbackResponse, StepUpStartResponse } from 'types/console';

// ==============================|| API - AUTH ||============================== //
//
// Sign-in, step-up and the session itself. Domain endpoints live in `api/dev` and `api/platform`.

export const authLogin = async (returnTo: string): Promise<AuthUrlResponse> =>
  (await api.get<AuthUrlResponse>('/v1/auth/login', { params: { returnTo } })).data;

export const authCallback = async (code: string, state: string): Promise<CallbackResponse> =>
  (await api.post<CallbackResponse>('/v1/auth/callback', { code, state })).data;

export const authLogout = async (): Promise<void> => {
  await api.post('/v1/auth/logout', undefined, SILENT);
};

export const stepUpStart = async (returnTo: string): Promise<StepUpStartResponse> =>
  (await api.post<StepUpStartResponse>('/v1/auth/step-up/start', { returnTo })).data;

export const stepUpCallback = async (code: string, state: string): Promise<StepUpCallbackResponse> =>
  (await api.post<StepUpCallbackResponse>('/v1/auth/step-up/callback', { code, state })).data;

export const fetchMe = async (): Promise<MeResponse> => (await api.get<MeResponse>('/v1/me')).data;
